const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "22px",
    viewBox: "0 0 12 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,18.431373%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 8.175781 5.941406 C 8.175781 4.898438 7.332031 4.054688 6.289062 4.054688 C 5.246094 4.054688 4.402344 4.898438 4.402344 5.941406 C 4.402344 6.980469 5.246094 7.828125 6.289062 7.828125 C 7.332031 7.828125 8.175781 6.980469 8.175781 5.941406 Z M 8.175781 5.941406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,18.431373%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 8.175781 11.59375 C 8.175781 10.554688 7.332031 9.707031 6.289062 9.707031 C 5.246094 9.707031 4.402344 10.554688 4.402344 11.59375 C 4.402344 12.636719 5.246094 13.480469 6.289062 13.480469 C 7.332031 13.480469 8.175781 12.636719 8.175781 11.59375 Z M 8.175781 11.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,18.431373%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 8.175781 17.253906 C 8.175781 16.214844 7.332031 15.367188 6.289062 15.367188 C 5.246094 15.367188 4.402344 16.214844 4.402344 17.253906 C 4.402344 18.296875 5.246094 19.140625 6.289062 19.140625 C 7.332031 19.140625 8.175781 18.296875 8.175781 17.253906 Z M 8.175781 17.253906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.9755244595d8a763eead049badf7f2b5.svg";
export { ForwardRef as ReactComponent };